import { APIColor, CfgProperty, CfgQuestion, CfgQuestionGroup, CfgQuestionValue, CfgStage, ElementGroup,ElementFilter,ElementPart, ElementsRoot, InitialContent, JElement, MaterialDefinition, MaterialTag, Part, ThumbnailScene } from './catalog-types'

// theres two calls for now: a fixed file and an API call. 
// The fixed file types are CAT (from catalog) prefixed and the API call types are API prefixed (if different from final types)
// They are combined to create the final, unprefixed types

// combined types

/*
    A material is what in JORI terminology is a quality.

    It is a combination of the catalog and service information
    (see APIMaterial and CATQuality)
*/
export interface Material {
    qualityId: string
    code: string
    mainColor: string
    tags: string[]
    name: string,
    general?: string
    technical?: string
    maintenance?: string
}

/*
    A material color is a combination of the catalog and service information
    (see APIColor and CATAsset).
    More that one colour can refer to presentation to the same asset.
    For example, some leathers different code for pipings and for general
    use, but point to the same asset.
*/
export interface MaterialColor {
    colorId: string
    assetId: string
    material: string
    qualityPath: string
    code: string
    name: string
    definition?: MaterialDefinition
    leatherAccent?: string
}

export interface MaterialRoot {
    tags: MaterialTag[]
    materials: Material[]
    colors: MaterialColor[]
}

// API types.
// This types are the ones that are used in the API calls, but not exactly
// what's transmitted throught the wire, but the result after some processing
// (choosing the right language, mostly)



export interface APIQuality {
    qualityId: string
    type: string
    description: string
    general: string
    technical: string
    maintenance: string
}

export interface APIMaterialRoot {
    colors: APIColor[]
    qualities: APIQuality[]
}


/* All the catalog in one place.

   elementRoot is kept here, although it is redundant, because there is
   code that depended on it, but should be removed at some point
*/

export type CatalogRoot = {
    materialTags: MaterialTag[]
    qualities: Material[]
    colors: MaterialColor[]

    compose: boolean
    initial?: InitialContent
    parts: Part[]
    elementGroups?: ElementGroup[] 
    elementFilter?: ElementFilter[]
    elements: JElement[]
    elementParts: ElementPart[]
    thumbnails?: ThumbnailScene[]
    attachProfiles?: Record<string, string[]>

    properties: CfgProperty[]
    stages: CfgStage[]
    questionGroups: CfgQuestionGroup[]
    questions: CfgQuestion[]
    values: CfgQuestionValue[]
    summaryProperties?: string[],

    elementsRoot: ElementsRoot
}

export const EMPTY_CATALOG_ROOT: CatalogRoot = {
    materialTags: [],
    qualities: [],
    colors: [],

    compose: false,
    parts: [],
    elements: [],
    elementParts: [],

    properties: [],
    stages: [],
    questionGroups: [],
    questions: [],
    values: [],

    elementsRoot: {
        elementParts: [],
        elements: [],        
    }
}